var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#FFF3E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#FFF9F2",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22866_22265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8102 25.4283L24.1479 27.839C25.2479 24.6792 26.1641 23.2926 28.2388 21.4105",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7534 23.1123C22.9322 22.451 22.7139 21.7223 21.9322 21.2016C20.3023 20.1161 18.3449 19.4834 16.2397 19.4834C14.1345 19.4834 12.1771 20.1161 10.5472 21.2016C8.73013 22.4118 9.95712 24.746 12.1403 24.746H19.4047C19.5204 24.3366 19.7424 23.9512 20.0699 23.6336C20.8041 22.9216 21.863 22.7504 22.7534 23.1123Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5513 24.746H12.1403C9.95712 24.746 8.73013 22.4118 10.5472 21.2016C12.1771 20.1161 14.1345 19.4834 16.2397 19.4834C18.3449 19.4834 20.3023 20.1161 21.9322 21.2016C22.3915 21.5075 22.6563 21.8852 22.7603 22.2789",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 16.6973C18.6197 16.6973 19.957 15.36 19.957 12.9825C19.957 10.605 18.6197 9.26761 16.2422 9.26761C13.8647 9.26761 12.5273 10.605 12.5273 12.9825C12.5273 15.36 13.8647 16.6973 16.2422 16.6973Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 16.6973C18.6197 16.6973 19.957 15.36 19.957 12.9825C19.957 10.605 18.6197 9.26761 16.2422 9.26761C13.8647 9.26761 12.5273 10.605 12.5273 12.9825C12.5273 15.36 13.8647 16.6973 16.2422 16.6973Z",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22866_22265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.95309 8.55331)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/attendance_icon.25f3d4004f276473c3da374cf4f24b85.svg";
export { ForwardRef as ReactComponent };